"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCancelToken = createCancelToken;
exports.timedRequest = timedRequest;
exports.isRetryableError = isRetryableError;
exports.updateOptionsWithResponse = updateOptionsWithResponse;
exports.calculateRate = calculateRate;

var _axios = _interopRequireWildcard(require("axios"));

var _cookie = _interopRequireDefault(require("cookie"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * Retrieves a token that can be used to cancel an http request.
 *
 * @returns {Object} Used to cancel an HTTP request.
 */
function createCancelToken() {
  return _axios.CancelToken.source();
}
/**
 * Submits an HTTP requests and provides the amount of time it took (in milliseconds) for the request to complete.
 * In addition, the method will retry the request according to the provided retry options.
 *
 * @param {object} requestOptions Will be passed as-is to the underlying HTTP request processor, axios.
 * @param {object} retryOptions Determines the behavior of the retry functionality.
 * @param {number} [retryOptions.retryCount] Specifies how many times, in total, the request will be submitted before giving up.
 * @param {number} [retryOptions.retryDelay] Specifies the amount of time to wait before retrying. The actual wait time will
 *   exponentially increase by this value for each retry.
 * @param {function} [retryOptions.onRetryError] Will be invoked with a single error before each retry. If all retries fail, the
 *   method will resolved with the last error instead. If this function throws an exception then the retry functionality
 *   will immediately be resolved with the thrown exception.
 * @param {Object} [cancelToken] If specified, can be used to cancel the request.
 * @returns {object} The response to the request, which will match the signature of an axios response. In addition
 *  to typical axios response data, the object will also have an "elapsedTime" property containing the amount
 *  of time (in milliseconds) it took for the request to complete.
 */


function timedRequest(_x, _x2, _x3) {
  return _timedRequest.apply(this, arguments);
}
/**
 * Determines whether a given error qualifies to be retried. Retryable errors include
 * network errors and 5xx level errors.
 * @param {*} e Error to check.
 * @returns {boolean} True if the error should be retried, false otherwise.
 */


function _timedRequest() {
  _timedRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(requestOptions, retryOptions, cancelToken) {
    var reqStart, options, response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            reqStart = new Date().getTime();
            options = _objectSpread({}, requestOptions);

            if (options.onRetryError) {
              delete options.onRetryError;
            }

            if (cancelToken) {
              options.cancelToken = cancelToken.token;
            }

            _context2.next = 6;
            return (0, _utils.exponentialRetry)(retryOptions, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return (0, _axios.default)(options);

                    case 2:
                      response = _context.sent;
                      response.elapsedTime = new Date().getTime() - reqStart;

                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })));

          case 6:
            return _context2.abrupt("return", response);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _timedRequest.apply(this, arguments);
}

function isRetryableError(e) {
  if (e && e.isAxiosError) {
    var _e$response = e.response,
        response = _e$response === void 0 ? {} : _e$response;
    var status = response.status; // only retry 5xx errors and errors that don't have a status code (which
    // indicates some kind of network or I/O error)

    if (status && (status < 500 || status > 599)) {
      return false;
    }
  }

  return true;
}
/**
 * Does any necessary work to update an existing options object with the results
 * of an HTTP response. For example, if the response contains a set-cookie header
 * then the cookies will be added to the options.
 *
 * @param {DirectBinaryUploadOptions} options Options to update.
 * @param {HttpResponse} response A response from an HTTP client request.
 */


function updateOptionsWithResponse(options, response) {
  var setCookie = response.getHeaders()['set-cookie'];

  if (setCookie && setCookie.length) {
    options.withCookies(_cookie.default.parse(setCookie[0]));
  }
}
/**
 * Calculate the rate of an HTTP transfer, in bytes per second.
 * @param {number} elapsed The total amount of time, in milliseconds, that
 *  the transfer has taken so far.
 * @param {number} totalTransferred The total number of bytes that have
 *  transferred so far.
 * @returns {number} Transfer rate, in bytes per second. Note that the
 *  rate will be 0 if not enough time has elapsed to get an accurate
 *  measurement.
 */


function calculateRate(elapsed, totalTransferred) {
  if (elapsed > 1000) {
    var elapsedSeconds = Math.round(elapsed / 1000);
    return Math.round(totalTransferred / elapsedSeconds);
  }

  return 0;
}